import { useFormContext, useWatch } from 'react-hook-form';

import * as S from './ChipStack.styled';

interface IProps {
  name: string;
}

export const ChipStack = ({ name }: IProps) => {
  const { control, setValue } = useFormContext();

  const items = useWatch({
    control,
    name,
  });

  const handleDelete = (item: string) => {
    setValue(
      name,
      items.filter((i: string) => i !== item)
    );
  };

  return (
    <S.Container>
      {items.map((item: string) => (
        <S.Chip key={`chip-${item}`} label={item} onDelete={() => handleDelete(item)} />
      ))}
    </S.Container>
  );
};
